import ModalPopup from "./ModalPopup";
import { useCookies } from 'react-cookie';
import React, { useState, useEffect } from "react";

function SelectCompanyModal({ setCurrentCompany }) {
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    let userCompanies = currentUser ? (currentUser.partnercompanies ?? null) : null;

    // Company IDs (as strings) the logged-in user is actually linked to.
    const validCompanyIds = (userCompanies || []).map((companyObj) => String(companyObj.value));

    const handleCompanyChange = (event) => {
        const selectedCompany = event.target.value;
        setCurrentCompany(selectedCompany);
        sessionStorage.setItem('selectedCompany', selectedCompany);
    };

    // Validate any pre-existing selection against the current user's companies on every load.
    // A stale or cross-account selection is cleared so the user must re-pick the correct company,
    // preventing signups from being mis-attributed to a dealership the user is not linked to.
    useEffect(() => {
        const storedCompany = sessionStorage.getItem('selectedCompany');
        if (storedCompany && validCompanyIds.includes(String(storedCompany))) {
            setCurrentCompany(storedCompany);
        } else if (storedCompany) {
            sessionStorage.removeItem('selectedCompany');
        }
    }, [validCompanyIds.join(",")]);

    const availableCompaniesCount = userCompanies?.length || 0;
    const storedCompany = sessionStorage.getItem('selectedCompany');
    const hasValidSelection = storedCompany && validCompanyIds.includes(String(storedCompany));

    if (availableCompaniesCount == 1) {
        setCurrentCompany(userCompanies[0].value);
        sessionStorage.setItem('selectedCompany', userCompanies[0].value);

    } else {
        if (availableCompaniesCount < 1 || hasValidSelection) {
            return;
        }
        else {
            console.log("User associated with multiple companies: ", userCompanies);
            return (
                <ModalPopup
                    showModal={true}
                    // handleShowModal={toggleDisplayDeleteConfirm}
                    popupTitle={"Select the Company for this Session"}
                    popupContent={
                        <div className="flex flex-column justify-center flex-row items-center p-4">
                            <p>Looks like you are associated to multiple companies, please select the company you want to use for this session:</p>
                            <select onChange={handleCompanyChange} className="text-2xl p-2">
                                <option key={null} value={null}>Select One</option>
                                {
                                    currentUser.partnercompanies.map((companyObj) => (<option key={companyObj.value} value={companyObj.value}>{companyObj.label}</option>))
                                }
                            </select>
                        </div>
                    }
                // cancelButtonText={'Cancel'}
                // confirmButtonText={'Delete'}
                // confirmCallbackAction={handleDeleteProductConfirm}
                />
            );
        }
    }



}
export default SelectCompanyModal;